import { render, staticRenderFns } from "./ConfirmationDialogHubCategory.vue?vue&type=template&id=1d5748a9"
import script from "./ConfirmationDialogHubCategory.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogHubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports